import { createSlice } from "@reduxjs/toolkit";

// スマホ版 参加物件 (BukkenMember) 専用のスライス。
// PC版/物件一覧 (stateBukken) とは独立に検索条件・結果・ページング・キーワードを保持する。
const initialState = Object.freeze({
  payloadBukkenMemberSearch: {},
  listBukkenMember: [],
  pageActive: 1,
  isSearchMode: true,
  searchText: ""
});

export const stateBukkenMemberSlice = createSlice({
  name: "stateBukkenMember",
  initialState,
  reducers: {
    setPayloadBukkenMemberSearchStore: (state, action) => {
      state.payloadBukkenMemberSearch = action.payload;
    },
    setListBukkenMemberStore: (state, action) => {
      state.listBukkenMember = action.payload;
    },
    setPageActiveBukkenMember: (state, action) => {
      state.pageActive = action.payload;
    },
    setIsSearchModeBukkenMember: (state, action) => {
      state.isSearchMode = action.payload;
    },
    setSearchTextBukkenMember: (state, action) => {
      state.searchText = action.payload;
    },
    resetStateBukkenMember: () => initialState
  }
});

export const {
  setPayloadBukkenMemberSearchStore,
  setListBukkenMemberStore,
  setPageActiveBukkenMember,
  setIsSearchModeBukkenMember,
  setSearchTextBukkenMember,
  resetStateBukkenMember
} = stateBukkenMemberSlice.actions;

export default stateBukkenMemberSlice.reducer;
